$bog_merchquarium_product_card $mol_card
	product_link? \
	catalog_link? \
	search? \
	cart_count? 0
	editable true
	Want_message @ \I want {title} if there is a reprint: {link}
	Want_title @ \I want it if there is a reprint
	Want_copied_title @ \✓ Copied — open {social}
	Share_copied_hint @ \Link copied
	Share_done_icon $mol_icon_check
	Tag* $mol_button_minor
		title <= tag_title* \
		click? <=> tag_select*? null
	attr *
		^
		bog_merchquarium_product_card_state <= status? \available
	sub /
		<= Cover $mol_view
			sub <= cover /
				<= Photos $bog_merchquarium_carousel
					ids <= photo_ids /string
					url* <= photo_url* \
				<= Photo_empty $mol_view
					sub /
						<= Photo_empty_icon $mol_icon_image_off
				<= Sold_badge $mol_paragraph
					title @ \Sold out
				<= Share $mol_button_minor
					hint <= share_hint @ \Share
					click? <=> share? null
					sub /
						<= share_icon $mol_icon_share_variant
		<= Info $mol_list
			rows <= info_rows /
				<= Title $mol_string_button
					value? <=> title? \
					hint @ \Title
					enabled <= changed true
				<= Price $bog_merchquarium_number
					value_min 0
					hint @ \Price
					value? <=> price? null
					enabled <= changed true
				<= Price_text $mol_paragraph
					title <= price_text \
				<= Description $mol_string_button
					value? <=> description? \
					hint @ \Description
					enabled <= changed true
				<= Description_text $mol_paragraph
					title <= description \
				<= Category $mol_select
					options <= category_list /
					option_label_default @ \Category
					enabled <= changed true
					value? <=> category? null
				<= Fandoms $mol_select_list
					value? <=> fandoms? /string
					dictionary <= fandom_dictionary *
					pick_hint @ \Fandoms
					enabled <= changed true
				<= Tags $mol_view
					sub <= tags /
		<= Cart_controls $mol_view
			sub <= cart_controls /
				<= Cart_add $mol_button_major
					title @ \Add to cart
					click? <=> cart_add? null
					enabled <= cart_enabled true
				<= Cart_counter $bog_merchquarium_counter
					value? <=> cart_count?
				<= Want $mol_button_minor
					title <= want_title \
					click? <=> want? null
					enabled <= want_enabled true
		- далее скрытые от клиента поля
		<= Admin $mol_row
			sub /
				<= Photos_add $mol_button_open
					files? <=> photos_add? /File
					enabled <= changed true
					accept \image/*
				<= Photos_delete $mol_button_minor
					title @ \Delete photo
					click? <=> photo_delete? null
					enabled <= photo_delete_enabled true
				<= Status $mol_switch
					value? <=> status? \available
					options *
						available @ \In stock
						sold @ \Sold out
						hidden @ \Hidden
					enabled <= changed true
				<= Delete $mol_button_minor
					title @ \Delete
					click? <=> product_delete? null
